/**
 * Custom rendition menu that only shows preferred codec levels
 * This replaces the default media-rendition-menu to show only filtered levels
 */

import { MediaRenditionMenu } from 'media-chrome/menu/media-rendition-menu.js';
import type { Rendition } from 'media-chrome/media-store/state-mediator.js';

interface FilteredLevel {
  level?: number;
  originalIndex?: number;
  width: number;
  height: number;
  bitrate: number;
}

class BunnyRenditionMenu extends MediaRenditionMenu {
  #filteredLevels: FilteredLevel[] = [];

  set filteredLevels(levels: FilteredLevel[]) {
    this.#filteredLevels = levels;
    // Trigger re-render when filtered levels are set
    this.requestUpdate?.();
  }

  // Override mediaRenditionList getter to return filtered levels when available
  get mediaRenditionList(): Rendition[] {
    if (this.#filteredLevels.length > 0) {
      return this.#filteredLevels.map((
        level: FilteredLevel,
        filteredIndex: number,
      ): Rendition => ({
        id: level.originalIndex?.toString() ?? `filtered-${filteredIndex}`,
        width: level.width,
        height: level.height,
        bitrate: level.bitrate,
      }));
    }
    return super.mediaRenditionList;
  }

  set mediaRenditionList(value: Rendition[]) {
    // Accept the value to prevent errors, but use filtered levels if available
    if (this.#filteredLevels.length === 0) {
      super.mediaRenditionList = value;
    }
  }
}

if (!globalThis.customElements.get('bunny-rendition-menu')) {
  globalThis.customElements.define('bunny-rendition-menu', BunnyRenditionMenu);
}

export default BunnyRenditionMenu;
